import * as angular from "angular";
import {IController} from "angular";

export class labelsTableRowCtrl implements IController {

  labelsTableCtrl: any;
  label: any;

  /* @ngInject */
  constructor() {
  }

}

angular
  .module('bringoz.admin.labels')
  .component('labelsTableRow', {
    require: {
      labelsTableCtrl: '^labelsTable'
    },
    bindings: {
      label: '<'
    },
    template: require('./labels-table-row.html').default,
    controller: labelsTableRowCtrl
  });
